import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';
import { CrmCompanyTypeSchema } from '../relationship/companies.schemas';

export const CrmCompanyCreatedPayloadSchema = z.object({
  companyId: z.uuid(),
  workspaceId: z.uuid(),
  organizationId: z.uuid(),
  type: CrmCompanyTypeSchema.nullable(),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});
export type CrmCompanyCreatedPayload = z.infer<typeof CrmCompanyCreatedPayloadSchema>;

const CrmCompanyMutationPayloadSchema = z.object({
  companyId: z.uuid(),
  workspaceId: z.uuid(),
  organizationId: z.uuid(),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});

export const CrmCompanyUpdatedPayloadSchema = CrmCompanyMutationPayloadSchema;
export type CrmCompanyUpdatedPayload = z.infer<typeof CrmCompanyUpdatedPayloadSchema>;

export const CrmCompanyArchivedPayloadSchema = CrmCompanyMutationPayloadSchema;
export type CrmCompanyArchivedPayload = z.infer<typeof CrmCompanyArchivedPayloadSchema>;

export const CrmCompanyUnarchivedPayloadSchema = CrmCompanyMutationPayloadSchema;
export type CrmCompanyUnarchivedPayload = z.infer<typeof CrmCompanyUnarchivedPayloadSchema>;

export const CrmCompanyDeletedPayloadSchema = CrmCompanyMutationPayloadSchema;
export type CrmCompanyDeletedPayload = z.infer<typeof CrmCompanyDeletedPayloadSchema>;

// Contact–company link events (IMM-4.3).
const CompanyContactLinkPayloadSchema = z.object({
  contactId: z.uuid(),
  companyId: z.uuid(),
  workspaceId: z.uuid(),
  organizationId: z.uuid(),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});

export const CrmCompanyContactLinkedPayloadSchema = CompanyContactLinkPayloadSchema;
export type CrmCompanyContactLinkedPayload = z.infer<typeof CrmCompanyContactLinkedPayloadSchema>;

export const CrmCompanyContactUnlinkedPayloadSchema = CompanyContactLinkPayloadSchema;
export type CrmCompanyContactUnlinkedPayload = z.infer<typeof CrmCompanyContactUnlinkedPayloadSchema>;

export const CrmCompanyContactLinkUpdatedPayloadSchema = CompanyContactLinkPayloadSchema;
export type CrmCompanyContactLinkUpdatedPayload = z.infer<typeof CrmCompanyContactLinkUpdatedPayloadSchema>;
